// src/pages/Login.js
import React, { useState } from 'react';
import { Box, Button, Input, VStack, useToast, Text, Flex } from '@chakra-ui/react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { BackgroundBeams } from "../ui/background-beams.tsx";

// Add this line to use the API_BASE_URL environment variable, if you set it up
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '/api';

export default function LoginPage() {
    // Changed 'username' state to 'email' for clarity and backend consistency
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const toast = useToast();
    const navigate = useNavigate();

    const handleLogin = async () => {
        setLoading(true);
        try {
            // Send login credentials to your Flask backend
            const response = await axios.post(`${API_BASE_URL}/login`, { // Use API_BASE_URL
                username,    // <-- CHANGE: Send 'email' matching backend's expectation
                password
            });

            // If login is successful, the backend should return an access_token
            if (response.data && response.data.token) { // <-- CHANGE: Look for 'access_token'
                // Store the token in localStorage for persistent authentication
                localStorage.setItem('demoAuthToken', response.data.token); // <-- CHANGE: Store 'access_token'

                toast({
                    title: 'Login Successful',
                    description: 'Redirecting to demo page...',
                    status: 'success',
                    duration: 1500,
                    isClosable: true,
                });
                // Redirect to your protected demo page
                navigate('/demo');
            } else {
                // This case should ideally not happen if backend sends proper errors
                throw new Error('No access_token received or unexpected response from server.');
            }
        } catch (error) {
            let errorMessage = 'Login failed. Please check your credentials.';
            if (error.response) {
                // If there's a response from the server, use its message if available
                if (error.response.data && error.response.data.message) { // Backend sends 'msg' not 'message' for errors
                    errorMessage = error.response.data.msg;
                } else if (error.response.status === 401) {
                    errorMessage = 'Invalid username or password.';
                }
            } else if (error.request) {
                // The request was made but no response was received (e.g., network error)
                errorMessage = 'Network error: Could not connect to the server.';
            } else {
                // Something happened in setting up the request that triggered an Error
                errorMessage = error.message;
            }

            toast({
                title: 'Error',
                description: errorMessage,
                status: 'error',
                duration: 3000,
                isClosable: true,
            });
            console.error('Login error:', error); // Log the full error for debugging
        } finally {
            setLoading(false);
        }
    };
    
    return (
        <Box
            py={12}
            px={6}
            position="relative"
            height="100vh"
            width="100vw"
            bg="black"
        >
            <BackgroundBeams />

            <Flex
                direction="column"
                justify="center"
                align="center"
                height="100%"
                width="100%"
                position="absolute"
                top="0"
                left="0"
                zIndex={1}
            >
                <VStack spacing={4} p={8} boxShadow="lg" rounded="md" bg="white" maxW="md" w="100%" mt="-50px">
                    <Text fontSize="2xl" fontWeight="bold" mb={4}>Demo Login</Text>
                    <Input
                        type="text"
                        placeholder="Username" //
                        value={username} //  
                        onChange={(e) => setUsername(e.target.value)} //
                        size="lg"
                        borderRadius="md"
                        borderColor="gray.300"
                        _hover={{ borderColor: 'blue.400' }}
                        _focus={{ borderColor: 'blue.500', boxShadow: 'outline' }}
                    />
                    <Input
                        type="password"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        size="lg"
                        borderRadius="md"
                        borderColor="gray.300"
                        _hover={{ borderColor: 'blue.400' }}
                        _focus={{ borderColor: 'blue.500', boxShadow: 'outline' }}
                    />
                    <Button
                        colorScheme="blue"
                        onClick={handleLogin}
                        isLoading={loading}
                        loadingText="Logging in..."
                        width="full"
                        size="lg"
                        borderRadius="md"
                    >
                        Login
                    </Button>
                </VStack>
            </Flex>
        </Box>
    );
}
